"use strict";

var _interopRequireDefault = require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _objectSpread2 = _interopRequireDefault(require("/home/runner/work/ap-cn-sfe-fe-pc/ap-cn-sfe-fe-pc/app/node_modules/@babel/runtime-corejs2/helpers/objectSpread2.js"));
require("core-js/modules/es6.function.name");
require("core-js/modules/web.dom.iterable");
var _axios = _interopRequireDefault(require("axios"));
var _ImagePreview = _interopRequireDefault(require("@/components/ImagePreview"));
var _preview = _interopRequireDefault(require("../noticeContent/components/preview"));
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  components: {
    PreviewBox: _preview.default,
    ImagePreview: _ImagePreview.default
  },
  data: function data() {
    var _this = this;
    return {
      pageName: 'notice',
      formLabelWidth: '120px',
      loadingComponent: null,
      listLoading: false,
      isLoading: false,
      searchVal: {},
      list: [],
      authData: [],
      authList: [],
      total: 0,
      currentId: null,
      currPage: 1,
      limit: 10,
      sourceApi: null,
      dialogVisible: false,
      viewData: '',
      fileList: [],
      lookupList: {
        NOTICE_STATUS_MAPPING: {}
      },
      form: {
        appMessagePk: '',
        appMessageCode: '',
        appMessageTitle: '',
        endTime: '',
        startTime: '',
        noticeImgUrl: '',
        noticeImgOriginalUrl: '',
        sn: ''
      },
      initForm: {
        appMessagePk: '',
        appMessageCode: '',
        appMessageTitle: '',
        endTime: '',
        startTime: '',
        noticeImgUrl: '',
        noticeImgOriginalUrl: '',
        sn: ''
      },
      rules: {
        // appMessageCode: [{ required: true, trigger: ['change'], message: this.$t('sfe.notice.error.appMessageCode') }],
        appMessageTitle: [{
          required: true,
          trigger: ['change'],
          message: this.$t('sfe.notice.error.appMessageTitle')
        }],
        endTime: [{
          required: true,
          trigger: ['change'],
          message: this.$t('sfe.notice.error.endTime')
        }]
        // sn: [{ required: false, trigger: ['change'], message: '' }],
        // noticeImgUrl: [{ required: true, trigger: ['change'], message: this.$t('sfe.notice.error.noticeImgUrl') }]
      },
      applicationIconFormData: null,
      isHideUploadIcon: false,
      isShowModel: false,
      isShowAuthModel: false,
      dialogStatus: '',
      isShowViewer: false,
      previewSrcList: [],
      initialIndex: 0,
      startStartDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.startEndTime) {
            return time.getTime() > new Date(_this.searchVal.startEndTime).getTime();
          }
        }
      },
      startEndDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.startStartTime) {
            return time.getTime() < new Date(_this.searchVal.startStartTime).getTime() - 3600 * 1000 * 24;
          }
        }
      },
      endStartDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.endEndTime) {
            return time.getTime() > new Date(_this.searchVal.endEndTime).getTime();
          }
        }
      },
      endEndDatetimeOptions: {
        disabledDate: function disabledDate(time) {
          if (_this.searchVal.endStartTime) {
            return time.getTime() < new Date(_this.searchVal.endStartTime).getTime() - 3600 * 1000 * 24;
          }
        }
      },
      startDatetimeOptionsModel: {
        disabledDate: function disabledDate(time) {
          if (_this.form.endTime) {
            return time.getTime() < Date.now() - 3600 * 1000 * 24 || time.getTime() > new Date(_this.form.endTime).getTime();
          } else {
            return time.getTime() < Date.now() - 3600 * 1000 * 24; // 今天及今天以后的日期
          }
        }
      },
      endDatetimeOptionsModel: {
        disabledDate: function disabledDate(time) {
          if (_this.form.startTime) {
            return time.getTime() < new Date(_this.form.startTime).getTime() - 3600 * 1000 * 24;
          } else {
            return time.getTime() < Date.now() - 3600 * 1000 * 24; // 今天及今天以后的日期
          }
        }
      }
    };
  },
  computed: {},
  watch: {
    isLoading: function isLoading(newValue) {
      // pc unlock 锁屏会导致页面晃动
      if (newValue) {
        this.loadingComponent = this.$loading({
          // lock: true,
          text: 'Loading',
          spinner: 'el-icon-loading',
          background: 'rgba(255, 255, 255, 0)'
        });
      } else {
        if (this.loadingComponent) {
          this.loadingComponent.close();
        }
      }
    },
    '$store.getters.language': function $storeGettersLanguage(newValue) {
      // 监听语言变更重新请求配置查询接口
      this.getLookupTypeCode();
    }
  },
  mounted: function mounted() {
    this.getLookupTypeCode();
    this.getRegionList();
  },
  methods: {
    tableIndex: function tableIndex(index) {
      return index + 1;
    },
    getLookupTypeCode: function getLookupTypeCode() {
      var _this2 = this;
      var param = {
        configItemCodeList: ['NOTICE_STATUS', 'Y_OR_N']
      };
      this.$api.common.getConfigItemByCode(param).then(function (res) {
        if (res.data) {
          _this2.lookupList = res.data || {};

          // 查找值数据转换
          for (var key in _this2.lookupList) {
            _this2.generateMapping(key, _this2.lookupList[key] || []);
          }
          _this2.searchData();
        }
      }).catch(function () {});
    },
    generateMapping: function generateMapping(title, dataList) {
      var _this3 = this;
      // 将查找值转换成所需数据格式
      this.lookupList["".concat(title, "_MAPPING")] = {};
      dataList.forEach(function (item) {
        var name = item.name,
          code = item.code;
        _this3.lookupList["".concat(title, "_MAPPING")][code] = name;
      });
    },
    getRegionList: function getRegionList() {
      var _this4 = this;
      this.$api.common.getRegionList(2).then(function (res) {
        _this4.authData = res.data;
      });
    },
    fetchData: function fetchData() {
      var _this5 = this;
      if (this.sourceApi) {
        this.sourceApi.cancel('cancel');
      }
      this.sourceApi = _axios.default.CancelToken.source();
      var param = {
        currPage: this.currPage,
        limit: this.limit,
        smodel: (0, _objectSpread2.default)((0, _objectSpread2.default)({}, this.searchVal), {}, {
          isPrivileged: this.searchVal.isAuth === 'Y' ? true : this.searchVal.isAuth === 'N' ? false : null
        })
      };
      this.listLoading = true;
      this.$api.notice.getList(param, this.sourceApi.token).then(function (res) {
        _this5.listLoading = false;
        _this5.list = res.data.items;
        _this5.total = res.data.totalCount;
      }).catch(function (err) {
        if (_axios.default.isCancel(err)) {
          return false;
        }
        _this5.listLoading = false;
      });
    },
    resetData: function resetData() {
      this.searchVal = {};
      this.searchData();
    },
    searchData: function searchData() {
      this.currPage = 1;
      this.fetchData();
    },
    create: function create() {
      var _this6 = this;
      this.dialogStatus = 'create';
      this.isShow = false;
      this.form = {
        appMessagePk: '',
        appMessageCode: '',
        appMessageTitle: '',
        endTime: '',
        startTime: '',
        noticeImgUrl: '',
        noticeImgOriginalUrl: '',
        sn: ''
      };
      this.initForm = {
        appMessagePk: '',
        appMessageCode: '',
        appMessageTitle: '',
        endTime: '',
        startTime: '',
        noticeImgUrl: '',
        noticeImgOriginalUrl: '',
        sn: ''
      };
      this.fileList = [];
      this.applicationIconFormData = null;
      this.isHideUploadIcon = false;
      this.isShowModel = true;
      this.$nextTick(function () {
        _this6.$refs['dataForm'].clearValidate();
      });
    },
    edit: function edit(row) {
      var _this7 = this;
      this.dialogStatus = 'edit';
      this.currentId = row.appMessagePk;
      if (!this.currentId === null) return;
      this.getDetail().then(function (res) {
        var appMessagePk = res.appMessagePk,
          appMessageCode = res.appMessageCode,
          appMessageTitle = res.appMessageTitle,
          endTime = res.endTime,
          startTime = res.startTime,
          noticeImgUrl = res.noticeImgUrl,
          noticeImgOriginalUrl = res.noticeImgOriginalUrl,
          sn = res.sn;
        _this7.form = {
          appMessagePk: appMessagePk,
          appMessageCode: appMessageCode,
          appMessageTitle: appMessageTitle,
          endTime: endTime,
          startTime: startTime,
          noticeImgUrl: noticeImgUrl,
          noticeImgOriginalUrl: noticeImgOriginalUrl,
          sn: sn
        };
        _this7.fileList = [{
          name: '',
          url: noticeImgUrl
        }];
        _this7.applicationIconFormData = null;
        _this7.isHideUploadIcon = true;
        _this7.initForm = (0, _objectSpread2.default)({}, _this7.form);
        _this7.isShowModel = true;
        _this7.$nextTick(function () {
          _this7.$refs['dataForm'].clearValidate();
        });
      });
    },
    editPage: function editPage(row) {
      this.$router.push({
        name: 'noticeContent',
        query: {
          appMessagePk: row.appMessagePk
        }
      });
    },
    getDetail: function getDetail() {
      var _this8 = this;
      return new Promise(function (resolve) {
        _this8.isLoading = true;
        _this8.$api.notice.getDetail(_this8.currentId).then(function (res) {
          _this8.isLoading = false;
          resolve(res.data);
        }).catch(function () {
          console.log('Data Request Fail');
          _this8.isLoading = false;
        });
      });
    },
    getPageDetail: function getPageDetail() {
      var _this9 = this;
      return new Promise(function (resolve) {
        _this9.isLoading = true;
        _this9.$api.notice.getPageDetail(_this9.currentId).then(function (res) {
          _this9.isLoading = false;
          resolve(res.data);
        }).catch(function () {
          console.log('Data Request Fail');
          _this9.isLoading = false;
        });
      });
    },
    getAuthDetail: function getAuthDetail() {
      var _this0 = this;
      return new Promise(function (resolve) {
        _this0.isLoading = true;
        _this0.$api.notice.getAuthDetail(_this0.currentId).then(function (res) {
          _this0.isLoading = false;
          resolve(res.data);
        }).catch(function () {
          console.log('Data Request Fail');
          _this0.isLoading = false;
        });
      });
    },
    view: function view(row) {
      var _this1 = this;
      this.currentId = row.appMessagePk;
      if (!this.currentId === null) return;
      this.getPageDetail().then(function (res) {
        _this1.viewData = res.appMessagePage;
        _this1.dialogVisible = true;
      });
    },
    auth: function auth(row) {
      var _this10 = this;
      this.currentId = row.appMessagePk;
      if (!this.currentId === null) return;
      this.getAuthDetail().then(function (res) {
        _this10.authList = res;
        _this10.dialogStatus = 'auth';
        _this10.isShowAuthModel = true;
      });
    },
    saveAuth: function saveAuth() {
      var _this11 = this;
      var param = {
        appMessagePk: this.currentId,
        areas: this.authList
      };
      this.$api.notice.auth(param).then(function (res) {
        if (res.success) {
          _this11.$message.success(_this11.$t('common.authSuccess'));
          _this11.isShowAuthModel = false;
        } else {
          _this11.$message.error(_this11.$t('common.authFail'));
        }
      }).catch(function () {});
    },
    publish: function publish(row) {
      var _this12 = this;
      this.$confirm(this.$t('sfe.notice.dialog.pulish'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this12.isLoading = true;
        _this12.$api.notice.publish(row.appMessagePk).then(function (res) {
          if (res.success) {
            _this12.$message.success(_this12.$t('sfe.notice.message.publishSuccess'));
            _this12.isLoading = false;
            _this12.searchData();
          } else {
            _this12.$message.error(_this12.$t('sfe.notice.message.publishFail'));
          }
        }).catch(function () {
          _this12.isLoading = false;
        });
      }).catch(function () {});
    },
    unpublish: function unpublish(row) {
      var _this13 = this;
      this.$confirm(this.$t('sfe.notice.dialog.unpublish'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this13.isLoading = true;
        _this13.$api.notice.unpublish(row.appMessagePk).then(function (res) {
          if (res.success) {
            _this13.$message.success(_this13.$t('sfe.notice.message.unpublishSuccess'));
            _this13.isLoading = false;
            _this13.searchData();
          } else {
            _this13.$message.error(_this13.$t('sfe.notice.message.unpublishFail'));
          }
        }).catch(function () {
          _this13.isLoading = false;
        });
      }).catch(function () {});
    },
    saveItem: function saveItem() {
      var _this14 = this;
      this.$refs['dataForm'].clearValidate();
      this.$refs.dataForm.validate(function (valid) {
        if (!valid) return;
        _this14.form.appMessageTitle = _this14.form.appMessageTitle.trim();
        var param = (0, _objectSpread2.default)({}, _this14.form);
        _this14.isLoading = true;
        _this14.$api.notice.saveItem(param).then(function (res) {
          _this14.$message.success(_this14.$t('common.saveSuccess'));
          _this14.isLoading = false;
          _this14.isShowModel = false;
          _this14.searchData();
        }).catch(function (err) {
          if (err.errorInfos && err.errorInfos.length > 0) {
            _this14.resetError();
            err.errorInfos.forEach(function (item) {
              _this14.errorKeys.push(item.key);
              _this14.errorInfo[item.key] = item.errMsg;
            });
            _this14.$refs['dataForm'].validate();
          }
          _this14.isLoading = false;
        });
      });
    },
    deleteItem: function deleteItem(row) {
      var _this15 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this15.isLoading = true;
        _this15.$api.notice.deleteItem(row.appMessagePk).then(function (res) {
          _this15.$message.success(_this15.$t('common.deleteSuccess'));
          _this15.isLoading = false;
          _this15.searchData();
        }).catch(function () {
          _this15.isLoading = false;
        });
      }).catch(function () {});
    },
    deleteArticle: function deleteArticle(row) {
      var _this16 = this;
      this.$confirm(this.$t('common.confirm1'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this16.isLoading = true;
        _this16.$api.notice.deleteArticle(row.appMessagePk).then(function (res) {
          _this16.isLoading = false;
          _this16.searchData();
        }).catch(function () {
          _this16.isLoading = false;
        });
      }).catch(function () {});
    },
    disable: function disable(row) {
      var _this17 = this;
      this.$confirm(this.$t('sfe.notice.dialog.disable'), this.$t('common.tip'), {
        confirmButtonText: this.$t('common.confirm'),
        cancelButtonText: this.$t('common.cancel'),
        type: 'warning'
      }).then(function () {
        _this17.isLoading = true;
        _this17.$api.notice.disable(row.appMessagePk).then(function (res) {
          if (res.success) {
            _this17.$message.success(_this17.$t('sfe.notice.message.disableSuccess'));
            _this17.isLoading = false;
            _this17.searchData();
          } else {
            _this17.$message.error(_this17.$t('sfe.notice.message.disableFail'));
          }
        }).catch(function () {
          _this17.isLoading = false;
        });
      }).catch(function () {});
    },
    handleRemove_icon: function handleRemove_icon(file, fileList) {
      var _this18 = this;
      this.fileList = [];
      this.form.noticeImgUrl = '';
      this.form.noticeImgOriginalUrl = '';
      this.applicationIconFormData = null;
      setTimeout(function () {
        _this18.isHideUploadIcon = false;
      }, 500);
    },
    checkFileList_icon: function checkFileList_icon(file, fileList) {
      this.applicationIconFormData = file.raw;
      if (this.applicationIconFormData) {
        this.isHideUploadIcon = true;
        this.uploadImg();
      } else {
        this.$message.error(this.$t('sfe.notice.error.upload'));
        this.isHideUploadIcon = false;
        this.applicationIconFormData = null;
      }
    },
    uploadImg: function uploadImg() {
      var _this19 = this;
      var param = new FormData();
      param.append('file', this.applicationIconFormData);
      param.append('businessKey', this.currentId);
      param.append('resourceConfigFlag', 'cms_internal_message');
      this.isLoading = true;
      this.$api.common.uploadFile(param).then(function (res) {
        _this19.isLoading = false;
        _this19.form.noticeImgUrl = res.data.url;
        _this19.form.noticeImgOriginalUrl = res.data.originUrl;
        _this19.isHideUploadIcon = true;
      }).catch(function () {
        _this19.isLoading = false;
        _this19.fileList = [];
        _this19.isHideUploadIcon = false;
        _this19.applicationIconFormData = null;
        _this19.form.noticeImgUrl = '';
        _this19.form.noticeImgOriginalUrl = '';
      });
    },
    openViewer: function openViewer(url) {
      if (!url) return;
      this.previewSrcList = [url];
      this.isShowViewer = true;
      document.body.style.overflow = 'hidden';
    },
    closeViewer: function closeViewer() {
      this.isShowViewer = false;
      document.body.style.overflow = '';
    }
  }
};